import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function FinalCTA() {
  return (
    <section className="py-20 bg-[#2C1E14]" data-testid="cta-final-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl text-white mb-6">
          Prêt à valoriser votre bien ou réserver un séjour d'exception ?
        </h2>
        <p className="text-white/70 max-w-2xl mx-auto mb-8">
          Ne laissez pas votre logement vide ou mal géré. Réservez directement l'un de nos logements ou confiez-nous la gestion de votre bien. Nos experts vous répondent sous 24h.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/voyageurs" className="btn-light inline-flex items-center justify-center gap-2" data-testid="cta-final-reserver">
            Réserver maintenant
          </Link>
          <Link to="/proprietaires#contact-form" className="btn-gold-outline inline-flex items-center justify-center gap-2" data-testid="cta-final-proprietaire">
            Confier mon bien <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
